var _circle, _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoCard2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 30,
    fill: "#F5F5F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.9953 45.1268C32.9953 49.2714 29.638 52.6288 25.4934 52.6288C21.3488 52.6288 17.9915 49.2714 17.9915 45.1268C17.9915 40.9823 21.3548 37.6249 25.4934 37.6249C29.632 37.6249 32.9953 40.9823 32.9953 45.1268Z",
    fill: "#EB001B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5041 37.6249C32.8224 37.6249 31.2719 38.1854 30.0196 39.1217H30.0256C30.2701 39.3602 30.5444 39.5272 30.7531 39.8015L29.1907 39.8254C28.9462 40.0699 28.7255 40.3382 28.5109 40.6185H31.26C31.4687 40.869 31.6655 41.0896 31.8384 41.3639H28.0099C27.8668 41.6084 27.7416 41.8529 27.6283 42.1094H32.2797C32.399 42.3658 32.5123 42.5626 32.6017 42.8309H27.354C27.2705 43.0873 27.1989 43.3557 27.1452 43.6241H32.8224C32.8761 43.8864 32.9178 44.125 32.9476 44.3695H27.0319C27.0081 44.614 26.9962 44.8644 26.9962 45.1209H32.9894C32.9894 45.3892 32.9715 45.6337 32.9417 45.8723H27.0319C27.0558 46.1287 27.0975 46.3791 27.1452 46.6236H32.8105C32.7508 46.8681 32.6852 47.1126 32.6017 47.3631H27.3361C27.4136 47.6195 27.515 47.87 27.6163 48.1145H32.2738C32.1426 48.3888 31.9994 48.6035 31.8384 48.8599H27.998C28.1471 49.1223 28.3141 49.3728 28.4989 49.6113L31.26 49.653C31.0214 49.9333 30.7233 50.1063 30.449 50.3567C30.4668 50.3687 30.0077 50.3567 29.1132 50.3388C30.4788 51.7462 32.3811 52.6228 34.4981 52.6228C38.6427 52.6228 42 49.2654 42 45.1209C42 40.9763 38.6486 37.6249 34.5041 37.6249Z",
    fill: "#F79E1B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5031 25L26.1297 33.5415H28.3254L29.6987 25H27.5031V25ZM34.1201 28.4786C33.3538 28.0997 32.8845 27.8457 32.8845 27.4583C32.8932 27.1052 33.2806 26.7436 34.1503 26.7436C34.8649 26.7264 35.3859 26.8943 35.7862 27.0579L35.9843 27.1483L36.2813 25.3616C35.8465 25.1937 35.162 25.0086 34.3139 25.0086C32.1484 25.0086 30.6243 26.1366 30.6114 27.7467C30.5942 28.9349 31.7049 29.5936 32.5358 29.9897C33.384 30.3944 33.6724 30.657 33.6724 31.0187C33.6638 31.574 32.9879 31.828 32.355 31.828C31.4811 31.828 31.0118 31.6946 30.2971 31.3889L30.0087 31.2554L29.703 33.111C30.2196 33.3392 31.1668 33.5415 32.1484 33.5501C34.4516 33.5501 35.9498 32.4394 35.9671 30.7259C35.9714 29.7917 35.3859 29.0684 34.1201 28.4786ZM41.9039 25.0258H40.2034C39.6824 25.0258 39.2821 25.1765 39.0582 25.7147L35.7992 33.5415H38.1024L38.7353 31.8453H41.3098L41.637 33.5458H43.6691L41.9039 25.0258ZM39.3768 30.1361C39.4198 30.1404 40.2593 27.3679 40.2593 27.3679L40.9266 30.1361C40.9266 30.1361 39.8073 30.1361 39.3768 30.1361ZM24.3 25L22.1474 30.8034L21.9149 29.6582C21.5188 28.3365 20.2703 26.9029 18.8798 26.1925L20.8472 33.5329H23.1677L26.6162 25H24.3Z",
    fill: "url(#paint0_linear)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1916 26.1034C21.0237 25.4534 20.4899 25.0142 19.7666 25.0056H16.3612L16.3268 25.1649C18.9831 25.8193 21.2089 27.8341 21.9321 29.7284L21.1916 26.1034Z",
    fill: "url(#paint1_linear)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.9843 12.0043C18.2469 12.0043 19.0304 11.9311 19.3619 13.0505C19.5858 13.8039 19.9431 15.0395 20.4296 16.7529H20.6277C21.1529 14.9448 21.5102 13.7092 21.7083 13.0505C22.0441 11.9182 22.8793 12.0043 23.2151 12.0043H25.7982V20.0464H23.1634V15.3064H22.9869L21.5188 20.0464H19.5385L18.0704 15.3064H17.8939V20.0464H15.2591V12.0043H17.9843ZM29.5825 12.0043V16.7443H29.7934L31.5801 12.8438C31.9288 12.0689 32.665 12 32.665 12H35.2137V20.0421H32.5229V15.3021H32.312L30.5597 19.2026C30.211 19.9732 29.4404 20.0464 29.4404 20.0464H26.8917V12.0043H29.5825ZM44.5129 15.823C44.1383 16.8864 42.9587 17.6484 41.6542 17.6484H38.8343V20.0421H36.277V15.823H44.5129Z",
    fill: "#0F754E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.7747 12.0043H36.1436C36.277 13.7952 37.8183 15.3279 39.4155 15.3279H44.6894C44.995 13.8383 43.9446 12.0043 41.7747 12.0043Z",
    fill: "url(#paint2_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 18.8824,
    y1: 29.277,
    x2: 43.6699,
    y2: 29.277,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#252764"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#24489E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 17.3221,
    y1: 24.0424,
    x2: 22.468,
    y2: 29.1882,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#252764"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#24489E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 44.7411,
    y1: 13.6637,
    x2: 36.1421,
    y2: 13.6637,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F5CD7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#02AEFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoCard2);
export default __webpack_public_path__ + "static/media/logo-card2.6ffed363fa9be79c3212596257191760.svg";
export { ForwardRef as ReactComponent };